<template>
  <div class="entry-layout">
      <aside-dashboard class="entry-layout_sidebar"/>
      <div class="entry-layout__main">
        <header-block/>
        <div class="dashboard_content">
          <router-view/>
        </div>
      </div>
    <notifier-block/>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import AsideDashboard from "../small_components/AsideDashboard";
import NotifierBlock from "../parts/NotifierBlock";
import HeaderBlock from "../parts/HeaderBlock";
export default {
  name: "DashboardEntryLayout",
  components: {
    HeaderBlock,
    NotifierBlock,
    AsideDashboard,
  },
  computed: {
    ...mapGetters([
      'getUserIsNew'
    ]),
  },
  created() {
    this.actionInitUserRoles()
    this.pageResized({target: window})
    window.addEventListener('resize', this.pageResized)
  },
  methods: {
    ...mapActions([
      'actionResolution',
      'actionInitUserRoles'
    ]),
    pageResized({target}) {
      this.actionResolution(target.innerWidth)
    },
  }
}
</script>
